import { render } from "./OrderModal.vue?vue&type=template&id=a6f1c254&scoped=true"
import script from "./OrderModal.vue?vue&type=script&lang=js"
export * from "./OrderModal.vue?vue&type=script&lang=js"

import "./OrderModal.vue?vue&type=style&index=0&id=a6f1c254&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f1c254"]])

export default __exports__